import YoungAgeModel from './YoungAgeModel';

export default YoungAgeModel;
